export const isPhone = (screen) => {
    return (screen.width >= 320 && screen.width < 641) || (window.innerWidth >= 320 && window.innerWidth < 641);
}

export const isTablet = (screen) => {
    return (screen.width <= 1023 && screen.width >= 641) || (window.innerWidth <= 1023 && window.innerWidth >= 641);
}